import type { CategoryMeta } from "@/types/movie";

export const categories: CategoryMeta[] = [
  {
    key: "movie",
    name: "电影",
    icon: "ri-movie-2-line",
    desc: "汇聚院线佳作、独立制片与经典重映，涵盖剧情、动作、科幻、悬疑等多元类型，为你筛选每一部值得一看的好电影。",
    genres: ["剧情", "喜剧", "动作", "爱情", "科幻", "悬疑", "犯罪", "家庭", "青春", "奇幻"],
  },
  {
    key: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "从都市情感、古装传奇到悬疑谍战，精选高分剧集与口碑新作，带你一次追完心头好剧。",
    genres: ["都市", "古装", "悬疑", "家庭", "谍战", "科幻", "冒险", "犯罪", "爱情", "奇幻"],
  },
  {
    key: "variety",
    name: "综艺",
    icon: "ri-mic-2-line",
    desc: "旅行、美食、音乐、竞技与脱口秀应有尽有，轻松解压的综艺世界，承包你的每一个休闲夜晚。",
    genres: ["旅行", "真人秀", "美食", "纪录片", "音乐", "竞技", "脱口秀", "喜剧"],
  },
];

export const regionsOptions = [
  "全部地区",
  "中国大陆",
  "中国香港",
  "美国",
  "日本",
  "韩国",
  "英国",
  "法国",
];

export const yearsOptions = [
  "全部年份",
  "2024",
  "2023",
  "2022",
  "2021",
];